// Global newwindow function that integrates with React
// This function will be available globally and can be called from CKEditor dialogs
import { logger } from './logger';

declare global {
  interface Window {
    newwindow: (a1: string, b1: string, c1: string, pageID?: string) => void;
    definitionModalOpen: (juriID: string, renID: string, refID: string, pageID?: string) => void;
  }
}

// Function to open the definition modal
// This will be called by the React context
let openDefinitionModal: ((juriID: string, renID: string, refID: string, pageID?: string) => void) | null = null;

export const setDefinitionModalOpener = (opener: (juriID: string, renID: string, refID: string, pageID?: string) => void) => {
  openDefinitionModal = opener;
};

// Global newwindow function that mimics the original CFM function
export const initializeNewwindow = () => {
  if (!globalThis.window) return;

  globalThis.window.newwindow = (a1: string, b1: string, c1: string, pageID: string = 'demo') => {
    logger.log('newwindow called with:', { a1, b1, c1, pageID });
    
    if (openDefinitionModal) {
      openDefinitionModal(a1, b1, c1, pageID);
    } else {
      logger.warn('Definition modal opener not initialized');
    }
  };

  // Also expose a direct function for React components
  globalThis.window.definitionModalOpen = (juriID: string, renID: string, refID: string, pageID: string = 'demo') => {
    if (openDefinitionModal) {
      openDefinitionModal(juriID, renID, refID, pageID);
    }
  };
};
